export function ShopifyLogo({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      viewBox="0 0 109.5 124.5"
      width="24"
      height="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M95.87 23.75a1.46 1.46 0 0 0-1.33-1.22c-.59-.04-11.82-.87-11.82-.87s-9.34-9.08-10.27-10a1.67 1.67 0 0 0-1.2-.41L65.92 124.5l37.42-8.07S95.93 24.29 95.87 23.75z"
        fill="#5E8E3E"
      />
      <path
        d="M73.25 11.25c-.93-.93-2.58-.67-3.34-.49 0 0-1.77.54-4.76 1.46a34.4 34.4 0 0 0-3.77-9.28C58.25-.72 54.68 0 54.68 0a4.49 4.49 0 0 0-1.24.14c-.25-.3-.49-.58-.77-.82C50.48-2.67 47.8-1.06 45.77 2.08a42.11 42.11 0 0 0-6.56 16.06l-8.54 2.65c-2.64.83-2.73.91-3.07 3.4S18 112.5 18 112.5l57.92 12 5.33-113.25zM60.63 15.73c-2.26.7-4.82 1.5-7.38 2.29v-1.61a27.63 27.63 0 0 0-1.49-9.76c3.71.53 6.18 4.84 8.87 9.08zm-12.82-8.44c.97 3.15 1.64 7.62 1.64 13.66v.62l-12.37 3.83c2.38-9.13 6.86-13.8 10.73-18.11zm-5.3-5.84c.66 0 1.33.22 1.96.64-5.07 5.97-10.48 15.32-12.95 24.86L22 29.87C24.77 18.79 33.3 1.45 42.51 1.45z"
        fill="#95BF47"
      />
      <path
        d="M54.68 48.73l-4.39 16.42s-3.83-2.05-8.53-2.05c-6.9 0-7.24 4.33-7.24 5.42 0 5.95 15.52 8.23 15.52 22.17 0 10.97-6.95 18.03-16.33 18.03-11.25 0-17.01-7-17.01-7l3.01-9.96s5.92 5.09 10.91 5.09a4.44 4.44 0 0 0 4.62-4.48c0-7.82-12.73-8.17-12.73-20.87 0-10.74 7.7-21.13 23.24-21.13 5.97 0 8.93 1.71 8.93 1.71v-3.35z"
        fill="#fff"
      />
    </svg>
  );
}
